import i18n from "shared/i18n";

const validate = (values) => {
  const errors = {};

  if (!values.username) {
    errors.username = i18n.t("Username is required");
  } else if (values.username.length > 254) {
    errors.username = i18n.t("Username must has no more than 254 symbols");
  } else if (values.username && values.username.length < 3) {
    errors.username = i18n.t("Username must be longer than 3 characters");
  }

  if (!values.email) {
    errors.email = i18n.t("Email is required");
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,24}$/i.test(values.email)) {
    errors.email = i18n.t("Invalid email address");
  }

  if (!values.password1) {
    errors.password1 = i18n.t("Password is required");
  }

  if (!values.password2) {
    errors.password2 = i18n.t("Password confirmation is required");
  }

  if (values.password1 !== values.password2) {
    errors.password2 = i18n.t("Password doesn't match");
  }

  if (values.password1 && values.password1.length < 8) {
    errors.password1 = i18n.t("Password must contain at least 8 characters");
  }

  if (values.password2 && values.password2.length < 8) {
    errors.password2 = i18n.t("Password must contain at least 8 characters");
  }

  return errors;
};

export default validate;
